import { UsersDetailsUplineTab } from "./UsersDetailsUplineTab";

export default UsersDetailsUplineTab;
